module.exports = __webpack_public_path__ + "static/img/img2.bf077b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/content/product/images/img2.png
// module id = wPzH
// module chunks = 1